import React from "react";
import { Link } from "react-router-dom";
import AddFormPlatform from "../components/AddFormPlatform";
import LogOut from "../components/LogOut";

const AddPlatform = () => {
  return (
    <div>
      <div className="navbar_admin">
        <LogOut />
        <h2>لوحة التحكم في حسابات العملاء</h2>
        <button className="add1">
          <Link to="/admin">العودة للرئيسية</Link>
        </button>
      </div>
      <div className="admin_area">
        <AddFormPlatform />
      </div>
    </div>
  );
};

export default AddPlatform;
